export const VIEW_ITEM_DATA_NOT_APPLICABLE = 'n/a';
export const VIEW_ITEM_ONLINE_SAMPLE_BRAND = 'online sample';
export const VIEW_ITEM_ONLINE_SAMPLE_LIST_NAME = 'Online Sample';
export const CARTOLOGY_NEW_PAST_ORDER = 'Cartology - New Past Order';
export const CARTOLOGY_NEW_FAVOURITES = 'Cartology - New Favourites';
export const SEARCH_CIG_CAROUSEL = 'Search CIG Carousel';
export const BROWSE_CIG_CAROUSEL = 'Browse CIG Carousel';
